import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Home.css';

// Import homepage sections
import HeroVideo from '../../components/Home/HeroVideo';
import PromotionSection from '../../components/Home/PromotionSection/';
import VideoWithText from '../../components/Home/VideoWithText';
import TeamGallery from '../../components/Home/TeamGallery';
import YouTubeVideo from '../../components/Home/YouTubeVideo';
// import ShopPromotion from '../../components/Home/ShopPromotion';
// import ClubPromotion1 from '../../components/Home/ClubPromotion1';
import ClubPromotion2 from '../../components/Home/ClubPromotion2';
import SignUp from '../../components/Home/Signup';
import Shop from '../../components/Home/Shop';
// import NewsSection from '../../components/Home/NewsSection';

const Home = () => {
  const location = useLocation();

  // Scroll to section if navigated from another page
  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.state]);


  return (
    <div className="home-page">
      <div id="hero-section">
        <HeroVideo />
      </div>

      <div id="about-us-section">
        <PromotionSection />
      </div>
      {/* about */}
      <div className='shop-section'>
        <Shop/>
      </div>
      {/* Section 3: Video with Title and Text */}
      <div id="video-section">
        <VideoWithText />
      </div>

      {/* Section 4: Team Gallery */}
      <div id="team-section">
        <TeamGallery />
      </div>

      {/* Section 5: YouTube Video */}
      <div id="youtube-section">
        <YouTubeVideo />
      </div>

      {/* Section 6: Shop Promotion */}
      {/* <div id="shop-section">
        <ShopPromotion />
      </div> */}

      {/* Section 7: Club Promotion 1 */}
      {/* <div id="club1-section">
        <ClubPromotion1 />
      </div> */}

      {/* Section 8: Club Promotion 2 */}
      <div id="club2-section">
        <ClubPromotion2 />
      </div>
      <div id='sign-up-section'>
        <SignUp />
      </div>

      {/* Section 9: News Section */}
      {/* <div id="news-section">
        <NewsSection />
      </div> */}
    </div>
  );
};

export default Home;
